import { useStoreActions, useStoreState } from '@mortgage-pos/ui/store'
import React, { useEffect, useState } from 'react'

interface PlaidContextType {
  usePlaidUpload: boolean
  setUsePlaidUpload: (usePlaidUpload: boolean) => void
  plaidModalOpen: boolean
  setPlaidModalOpen: (plaidModalOpen: boolean) => void
}

const PlaidContext = React.createContext<PlaidContextType | null>(null)

interface PlaidProviderProps {
  children: React.ReactNode
}

export function PlaidProvider({ children }: PlaidProviderProps) {
  const [usePlaidUpload, setUsePlaidUpload] = useState<boolean | undefined>(
    undefined
  )
  const [plaidModalOpen, setPlaidModalOpen] = useState<boolean>(false)

  const accounts = useStoreState((state) => state.plaid.accounts)

  const getConnectedAccounts = useStoreActions(
    (actions) => actions.plaid.getConnectedAccounts
  )

  useEffect(() => {
    getConnectedAccounts()
  }, [])

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      setUsePlaidUpload(true)
    }
  }, [accounts])

  return (
    <PlaidContext.Provider
      value={{
        usePlaidUpload,
        setUsePlaidUpload,
        plaidModalOpen,
        setPlaidModalOpen,
      }}
    >
      {children}
    </PlaidContext.Provider>
  )
}

export function usePlaid(): PlaidContextType {
  const referenceProduct = React.useContext(PlaidContext)
  if (!referenceProduct) {
    throw new Error('usePlaid must be used within a PlaidContext')
  }
  return referenceProduct
}

export default PlaidContext
